/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_admin_contact_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact submissions`)
};

const es_admin_contact_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensajes de contacto`)
};

const de_admin_contact_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktnachrichten`)
};

const nl_admin_contact_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactinzendingen`)
};

const fr_admin_contact_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages de contact`)
};

const it_admin_contact_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggi di contatto`)
};

const pt_br2_admin_contact_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagens de contato`)
};

const pt_admin_contact_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagens de contacto`)
};

const ja_admin_contact_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ一覧`)
};

const zh_admin_contact_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系信息`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const admin_contact_heading = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.admin_contact_heading(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("admin_contact_heading", locale)
	if (locale === "en") return en_admin_contact_heading(inputs)
	if (locale === "es") return es_admin_contact_heading(inputs)
	if (locale === "de") return de_admin_contact_heading(inputs)
	if (locale === "nl") return nl_admin_contact_heading(inputs)
	if (locale === "fr") return fr_admin_contact_heading(inputs)
	if (locale === "it") return it_admin_contact_heading(inputs)
	if (locale === "pt-BR") return pt_br2_admin_contact_heading(inputs)
	if (locale === "pt") return pt_admin_contact_heading(inputs)
	if (locale === "ja") return ja_admin_contact_heading(inputs)
	return zh_admin_contact_heading(inputs)
};